import { render, staticRenderFns } from "./BannerDate.vue?vue&type=template&id=0e837693&"
import script from "./BannerDate.vue?vue&type=script&lang=js&"
export * from "./BannerDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports